// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-font-color":"#000000","checkbox":"_1vfZVj4","checkbox_label":"_1d-n-fj"};